export default __webpack_public_path__ + "static/media/juiceOrange.46184173.png";